import ClubInvoicePayment from './ClubInvoicePayment.js';
import ClubReverseInvoice from './ClubReverseInvoice.js';

export default class ClubInvoice {
    static STATUS_PAID = 'paid';
    static STATUS_OPEN = 'open';
    static STATUS_UNEQUAL = 'unequal';
    static STATUS_CHARGEBACK = 'chargeback';

    static PAYMENT_METHOD_SEPA_DEBIT = 'sepa-debit';
    static PAYMENT_METHOD_BANK_TRANSFER = 'bank-transfer';
    static PAYMENT_METHOD_CASH = 'cash';
    static PAYMENT_METHOD_INDEFINITE = 'indefinite';

    static fromData(data) {
        if (!data) {
            return;
        }

        const clubInvoice = new ClubInvoice();
        clubInvoice.active = false;
        clubInvoice.id = data.id;
        clubInvoice.isReverseInvoice = false;
        clubInvoice.number = data.number;
        clubInvoice.canceled = data.canceled;
        clubInvoice.reverseInvoice = ClubReverseInvoice.fromData(data.reverseInvoice);
        clubInvoice.createdAt = data.createdAt;
        clubInvoice.invoiceRecipient = data.invoiceRecipient;
        clubInvoice.status = data.status;
        clubInvoice.dunningStatus = data.dunningStatus;
        clubInvoice.dunningStatusHistory = data.dunningStatusHistory;
        clubInvoice.dunningAmount = data.dunningAmount;
        clubInvoice.dunningFee = data.dunningFee;
        clubInvoice.enabledDunningStatus = data.enabledDunningStatus;
        clubInvoice.dunningStatusMessage = data.dunningStatusMessage;

        if (data.chargeback !== null) {
            clubInvoice.chargeback = {
                clubFee: data.chargeback.clubFee,
                createdAt: data.chargeback.createdAt,
                reason: data.chargeback.reason,
                amount: data.chargeback.amount,
                pdfExists: data.chargeback.pdfExists,
                pdfLastDownload: data.chargeback.pdfLastDownload,
                pdfLastDownloadByMember: data.chargeback.pdfLastDownloadByMember,
                pdfLastSentAsEmail: data.chargeback.pdfLastSentAsEmail,
                pdfLastSentAsEmailFinished: data.chargeback.pdfLastSentAsEmailFinished,
            };
        } else {
            clubInvoice.chargeback = null;
        }

        clubInvoice.paymentMethod = data.paymentMethod;
        clubInvoice.gross = data.gross;
        clubInvoice.currency = data.currency;
        clubInvoice.assets = data.assets.data.map((asset) => {
            return {
                id: asset.id,
                consumer: {
                    id: asset.consumer.id,
                    name: asset.consumer.name,
                },
            };
        });
        clubInvoice.pdfExists = data.pdfExists;
        clubInvoice.payoffMethod = data.payoffMethod;
        clubInvoice.pdfLastDownload = data.pdfLastDownload;
        clubInvoice.pdfLastDownloadByMember = data.pdfLastDownloadByMember;
        clubInvoice.pdfLastSendAsEmail = data.pdfLastSendAsEmail;
        clubInvoice.pdfLastSendAsEmailFinished = data.pdfLastSendAsEmailFinished;
        clubInvoice.xInvoiceExists = data.xInvoiceExists;
        clubInvoice.dunningPdfs = data.dunningPdfs;
        clubInvoice.deletable = data.deletable;
        clubInvoice.payments = data.payments.data.map((payment) => {
            return ClubInvoicePayment.fromData(payment);
        });

        Object.seal(clubInvoice);
        return clubInvoice;
    }

    isNegative() {
        return this.gross.data.numerator / this.gross.data.denominator < 0;
    }

    isPaymentRequired() {
        return this.getBalance() > 0;
    }

    isPayoffRequired() {
        return this.getBalance() < 0;
    }

    getBalance() {
        const invoiceAmount = this.canceled ? 0 : this.gross.data.numerator / this.gross.data.denominator;
        return this.payments.reduce((accumulator, payment) => accumulator - payment.money.numerator / payment.money.denominator, invoiceAmount);
    }
}
